'use client';
import { FC } from "react";
import Container from "@/layouts/Container.layout";
import cn from "classnames";
import type { RichTextVideoSection } from "@/utils/strapi/sections/RichTextVideo";
import Aspect from "@/components/Aspect/Aspect";
import Button from "@/components/Button/Button";
import { useRouter } from "next/navigation";
import { RichTextRenderer } from "@/components/RichTextRenderer/RichTextRenderer";

const RichTextVideo: FC<RichTextVideoSection> = (props: RichTextVideoSection) => {
  const {
    title,
    text,
    videoPosition = "left",
    backgroundColor,
    richTextVideoContentVariant: contentVariant = "dark",
    providerId,
    provider,
    buttons
  } = props;

  const router = useRouter();

  const renderVideo = () => {
    return (
      <div className="w-full h-full" >
        <Aspect ratio="2/1">
        <iframe 
        className="w-full h-full"
        src={provider==='Youtube'? `https://www.youtube.com/embed/${providerId}`: provider ==='Vimeo'? `https://player.vimeo.com/video/${providerId}`:''} 
        title="YouTube video player" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen>
       </iframe></Aspect>
      </div>
    );
  };

  return (
    <section
      style={{ backgroundColor }}
      className={cn({
        "mobile:py-10 tablet:py-6 desktop:py-10": !!backgroundColor,
        "text-white": contentVariant === "light",
      })}
    >
      <Container>
        <div className="flex flex-col space-y-6">
          
          <div className="grid mobile:grid-cols-1 tablet:grid-cols-1 grid-cols-2 gap-6  items-center">
            <div
              className={cn({
                "desktop:hidden": videoPosition !== "left",
                "mobile:hidden tablet:hidden": !!title
              })}
            >
              {renderVideo()}
            </div>
            {
              text
                && ( <div className="dark ">
                  { title && <h3 className="font-headings text-4xl pb-4 font-bold leading-tight tablet:text-5xl mobile:text-6">{title}</h3>}
                    <RichTextRenderer content={text}/>
                   {
                    buttons && buttons?.length > 0 ?
                    <div className="grid gap-6 desktop:grid-cols-2 tablet:grid-cols-2">
                    {
                      buttons?.map((item, i) => {
                        return (
                          <div key={`richTextVideo-button-${i}`}>
                          <Button 
                          intent="black"
                          variant="solid"
                          size="sm"
                          icon={item?.iconName}
                          className="w-full bg-surface-950 border-surface-950 hover:border-surface-950 hover:bg-surface-0 hover:text-surface-950 text-surface-0"
                          onClick={() => router?.push(item?.CTA)}>{item?.label}</Button>
                        </div>
                        )}
                      )
                    }
                  </div>
                    : null
                  }
                  </div>)
            }
            <div 
              className={cn({
                "desktop:hidden": videoPosition !== "right",
                "mobile:hidden tablet:hidden": !title
              })}
            >
              {renderVideo()}
            </div>
          </div>
        </div>
      </Container>
    </section>
  )
}

export default RichTextVideo